import { initializeApp } from "firebase/app";
import { collection, getDocs, getFirestore } from "firebase/firestore";
import { useEffect, useState } from "react";
import { GameData } from "./Game";

const firebaseConfig = {
    apiKey: "AIzaSyD7_xsdMY22RaGNc2rnbRKkFPuubm9Plws",
    authDomain: "qwickhub.firebaseapp.com",
    projectId: "qwickhub",
    storageBucket: "qwickhub.appspot.com",
    messagingSenderId: "198513542138",
    appId: "1:198513542138:web:f6890b84e2dbac0fb69a43",
    measurementId: "G-VE4PTBPS7F"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);

export const useGames = () => {
    const [games, setGames] = useState<GameData[] | undefined>(undefined);

    useEffect(() => {
        (async () => {
            const g = (await getDocs(collection(db, "games"))).docs.map(
                doc => ({ ...doc.data(), id: doc.id } as GameData)
            );
            setGames(g);
        })();
    }, []);

    return games;
};
